import { TLS_ONLINE_CLIENT_ID } from '../constants/travelerDataConstants';

export const getPayloadForClearContext = () => ({
  context: [
    {
      code: 'HOTEL_ABANDON',
      value: 'CLEAR',
    },
  ],
});

export const formatDate = (date, locale = 'en-US') => new Date(date).toLocaleDateString(locale, {
  month: 'numeric',
  day: 'numeric',
  year: '2-digit',
  timeZone: 'UTC',
});

export const capitalize = (str) => str[0].toUpperCase() + str.slice(1);

export const isValidHotelDisplayDate = (hotelDate) => {
  const formattedCurrentDate = new Date(formatDate(Date.now()));
  formattedCurrentDate.setHours(-48);

  const formattedHotelDate = new Date(formatDate(hotelDate));

  return formattedCurrentDate.getTime() < formattedHotelDate.getTime();
};

export const getContextDetails = ({
  abandonCartData,
}) => Object
  .entries(abandonCartData)
  .map(([key, value]) => ({ code: capitalize(key), value }));

export const getPayloadForContextFeedbackLoop = ({
  abandonCartData,
}) => ({
  eventPayload: {
    channelName: TLS_ONLINE_CLIENT_ID,
    intentCode: 'Abandon Cart Feedback',
    intentDescription: 'Abandon Cart Feedback',
    details: [
      {
        code: 'ContextDisposition',
        value: 'Clicked',
      },
      {
        code: 'ClickedTime',
        value: new Date().toISOString(),
      },
      ...getContextDetails({ abandonCartData }),
    ],
  },
  eventSource: TLS_ONLINE_CLIENT_ID,
  eventTransferDate: new Date().toISOString(),
  eventType: 'GLOBAL_ONLINE_TLSONLINE_FEEDBACK',
});
